module.exports = __webpack_public_path__ + "img/application6.1f746e14.png";